// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pro .tips[data-v-b1a4587c]{height:50px;line-height:50px;color:#999;font-size:12px;border-bottom:1px solid rgba(0,0,0,.05)}.pro .btn-box[data-v-b1a4587c]{padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
